import { BaseModel } from '../../models/base.model';
import { JsonProperty } from '../../utils/json-typescript-mapper';

export class CellPhoneUpdateRequest extends BaseModel<CellPhoneUpdateRequest> {

    @JsonProperty('CellPhoneNumber')
    cellPhoneNumber: number;

    constructor(properties?: Partial<CellPhoneUpdateRequest>) {
        super({
            cellPhoneNumber: undefined
        }, properties);
    }
}
